import $ from 'jquery';
import JQueryView, { on } from '../../../jqueryView';

export default class SelectPatternView extends JQueryView {
  constructor() {
    super('.simple_form');

    this.render();
  }

  @on({ event: 'change', selector: 'input[type="radio"]' })
  onChangeRadioButtons() {
    this.render();
  }

  canSubmit() {
    return 0 < $('input[type="radio"]:checked').length;
  }

  render() {
    if (this.canSubmit()) {
      $('#btn-submit').prop('disabled', false);
    } else {
      $('#btn-submit').prop('disabled', true);
    }
  }
}
